export default function calcDifferenceInDays(date1: Date, date2: Date): number {
  if (!date1 || !date2) {
    return 0
  }
  const timeDifference = date2.getTime() - date1.getTime()
  return Math.floor(timeDifference / (1000 * 60 * 60 * 24))
}
